<template lang="html">
  <div :class="{'subMenuItem':true, 'close-panel':!disabled}"
    @click="$emit('click')"
    :disabled="disabled" >
      <span v-if="labelId && labelId !== ''">{{ $t(labelId) }}</span>
      <span v-else>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'MobileMenuSectionListItem',
  props: ['label', 'labelId', 'disabled']
}
</script>

<style lang="css" scoped>
.subMenuItem {
  /* color: #ddd; */
  /* border: 1px solid darkgreen; */
  font-size: 16px;
  margin-bottom: 15px;
}
.subMenuItem:hover, .profileInformationContainer:hover {
  cursor: pointer;
  background-color: #FFFFFF;
  color: #000;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// MobileMenuSectionListItem.vue?faeae1c6